/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type VocabWordReviewLevelDto = {
  jlptLevel: VocabWordReviewLevelDto.jlptLevel;
  total: number;
};
export namespace VocabWordReviewLevelDto {
  export enum jlptLevel {
    N5 = "N5",
    N4 = "N4",
    N3 = "N3",
    N2 = "N2",
    N1 = "N1",
  }
}
